"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Report = void 0;

var Report =
/** @class */
function () {
  function Report(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - eventId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param string? - sortBy createdAt
   * @param string? - sortDirection ascending|descending
   * @return Promise|Observable|any
   */


  Report.prototype.ListReportsForEvent = function (eventId, page, itemsPerPage, sortBy, sortDirection) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Report/UseCase/ListReportsForEvent', {
      eventId: eventId,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  };
  /**
   * @param number - startTime
   * @param number - endTime
   * @return Promise|Observable|any
   */


  Report.prototype.ReportTotalEventsRunningBetweenDates = function (startTime, endTime) {
    return this.restClient.get('Report/UseCase/ReportTotalEventsRunningBetweenDates', {
      startTime: startTime,
      endTime: endTime
    });
  }; // Commands

  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateActivityLogReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateActivityLogReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateAdminEventReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateAdminEventReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateConfirmedGuestReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateConfirmedGuestReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateEmailDeliverabilityReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateEmailDeliverabilityReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateGraphicalCheckinReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateGraphicalCheckinReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateGuestSummaryReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateGuestSummaryReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreatePurchasedReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreatePurchasedReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateSentEmailReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateSentEmailReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string - ticketBlockId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateTicketBlockSummaryReport = function (eventId, ownerUserId, ticketBlockId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateTicketBlockSummaryReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      ticketBlockId: ticketBlockId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateTicketBlockUserReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateTicketBlockUserReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateTransferReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateTransferReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateUnconfirmedGuestReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateUnconfirmedGuestReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateWaitListReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateWaitListReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };
  /**
   * @param string - eventId
   * @param string - ownerUserId
   * @param string? - name
   * @param string? - reportId
   * @return Promise|Observable|any
   */


  Report.prototype.CreateWaiverReport = function (eventId, ownerUserId, name, reportId) {
    if (name === void 0) {
      name = null;
    }

    if (reportId === void 0) {
      reportId = null;
    }

    return this.restClient.post('Report/UseCase/CreateWaiverReport', {
      eventId: eventId,
      ownerUserId: ownerUserId,
      name: name,
      reportId: reportId
    });
  };

  return Report;
}();

exports.Report = Report;